export default class PvrService {
	constructor(apiService) {
		this.apiService = apiService
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('me/pvrs/' + id, params)
	}
}



// WEBPACK FOOTER //
// ./src/service/PvrService.js